// This file defines constants for the geometry types provided by OpenLayers.
// https://openlayers.org/en/latest/apidoc/module-ol_geom_Geometry.html
// It should not contains anything not listed in the above link.

export const POINT = 'Point';
export const LINE_STRING = 'LineString';
export const LINEAR_RING = 'LinearRing';
export const POLYGON = 'Polygon';
export const MULTI_POINT = 'MultiPoint';
export const MULTI_LINE_STRING = 'MultiLineString';
export const MULTI_POLYGON = 'MultiPolygon';
export const GEOMETRY_COLLECTION = 'GeometryCollection';
export const CIRCLE = 'Circle';

const GeometryType = {
    POINT,
    LINE_STRING,
    LINEAR_RING,
    POLYGON,
    MULTI_POINT,
    MULTI_LINE_STRING,
    MULTI_POLYGON,
    GEOMETRY_COLLECTION,
    CIRCLE
};

export default GeometryType;
